module.exports = __webpack_public_path__ + "img/businessman.49f4b79e.svg";